export default function isValidPassword(password) {
    //at least one lowercase, one uppercase, and one number. Special symbols allowed, but not required
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]+$/g;
    const regex = new RegExp(pattern);
    return regex.test(password);
}
